const CHANNEL_OPTIONS = ["SMS", "WHATSAPP", "EMAIL", "WEBHOOK"];
const TENANT_NOTIFICATION_TYPE_OPTIONS = ["BEFORE_DUE", "ON_DUE", "AFTER_DUE"];
const TENANT_SCOPE_OPTIONS = ["ALL_TENANCIES"];
const PAYOUT_NOTIFICATION_TYPE_OPTIONS = ["BEFORE_PAYDAY", "ON_PAYDAY", "AFTER_PAYDAY"];
const DISPATCH_STATUS_OPTIONS = ["PENDING", "SENT", "FAILED", "SKIPPED"];

export {
  CHANNEL_OPTIONS,
  TENANT_NOTIFICATION_TYPE_OPTIONS,
  TENANT_SCOPE_OPTIONS,
  PAYOUT_NOTIFICATION_TYPE_OPTIONS,
  DISPATCH_STATUS_OPTIONS,
};
